@if (data$ | async) {
  <div class="container">
    <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="center center">
      <span fxFlex></span>
      <div fxLayout="column" fxLayoutGap="4px" fxLayoutAlign="end end">
        @if (languages?.length) {
          <div>
            <nz-select
              style="width: 128px"
              [(ngModel)]="selectedLanguage"
              (ngModelChange)="selectLanguage.next(selectedLanguage)"
              >
              @for (lang of languages; track lang) {
                <nz-option
                  [nzValue]="lang.code"
                  [nzLabel]="lang.name"
                ></nz-option>
              }
            </nz-select>
          </div>
        }
        <div>
          <nz-button-group>
            @for (format of formats; track format) {
              <button
                type="button"
                nz-button
                [nzLoading]="isFormatLoading('download', format.value) | async"
                (click)="downloadPdf('download', format.value)"
                >
                <span nz-icon nzType="download"></span>
                Download PDF
                @if (format.name) {
                  &nbsp;({{ format.name }})
                }
              </button>
            }
          </nz-button-group>
        </div>
        <div>
          <nz-button-group>
            @for (format of formats; track format) {
              <button
                type="button"
                nz-button
                [nzLoading]="isFormatLoading('print', format.value) | async"
                (click)="downloadPdf('print', format.value)"
                >
                <span nz-icon nzType="printer"></span>
                Print PDF
                @if (format.name) {
                  &nbsp;({{ format.name }})
                }
              </button>
            }
          </nz-button-group>
        </div>
      </div>
    </div>
    <br />
    <div class="card mat-padding-2">
      <ng-content></ng-content>
    </div>
  </div>
} @else {
  <br /><br />
  <div class="card mat-padding-2">
    <nz-spin nzSimple></nz-spin>
  </div>
}

